import {
  GetPersonRequest,
  ParticipantsPersonApi
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { useCallback, useMemo } from 'react';
import { handleError } from 'utils';
import { useGetDDServiceApiConfiguration } from './dd.service';

export const useParticipantsPersonApi = () => {
  const configuration = useGetDDServiceApiConfiguration();
  const apiInstance = useMemo(
    () => new ParticipantsPersonApi(configuration),
    [configuration]
  );

  const getPerson = useCallback(
    (requestParameters: GetPersonRequest) =>
      apiInstance.getPerson(requestParameters).catch(handleError),
    [apiInstance]
  );

  return {
    getPerson
  };
};
